module.exports = __webpack_public_path__ + "static/media/sort-size-down-alt.d0524c7a.svg";